__turbopack_context__.v({
  "bioContainer": "LeaderboardPage-module-scss-module__NGh6nq__bioContainer",
  "leaderboardPage": "LeaderboardPage-module-scss-module__NGh6nq__leaderboardPage",
  "tableContainer": "LeaderboardPage-module-scss-module__NGh6nq__tableContainer",
  "tabsWrapper": "LeaderboardPage-module-scss-module__NGh6nq__tabsWrapper",
});
